import React, { PureComponent } from 'react';
import shortid from 'shortid';
import AboutManager from '../managers/AboutManager';

class About extends PureComponent {
  constructor() {
    super();
    this.about = new AboutManager();
  }

  getMessage() {
    return (
      <div>
        {this.about.getMessage().map(message => (
          <div key={`div-${shortid.generate()}`}>
            <div className="font-paragraph">{message}</div>
            <div className="contact__space">&nbps;</div>
          </div>
        ))}
      </div>
    );
  }

  getSkills() {
    const skill = [];
    const skills = this.about.getSkills();

    for (let i = 0; i < skills.length; i += 1) {
      const aboutSkill = skills[i];

      skill.push(
        <div
          className="about__skill_container__col about__padding"
          key={`div-${shortid.generate()}`}
        >
          <div className="font-title-semi_bold about__subtitle about__padding">
            {aboutSkill.getTitle()}
          </div>
          <div>
            {aboutSkill.getList().map(skillItem => (
              <div className="font-paragraph about__skill " key={`div-${shortid.generate()}`}>
                {skillItem}
              </div>
            ))}
          </div>
        </div>,
      );
    }
    return (
      <div className="about__skill_container">
        {' '}
        {skill}
      </div>
    );
  }

  render() {
    return (
      <div className="about">
        <div className="contact__content contact__left">
          <div className="about--left">
            <img className="about__image" alt="Daniel Rodriguez" src="/me.jpg" />
          </div>
          <div className="contact__content--right">
            <div className="font-title-semi_bold about__title">{this.about.getTitle()}</div>
            <div className="contact__content--left">{this.getMessage()}</div>
          </div>
        </div>
        <div className="about__bottom_pad" />
        <div className="about__padding">
          <div className="about__padding about__bg_color">
            <div className="font-title-semi_bold about__title about__padding ">
              {this.about.getSkillsTitle()}
            </div>
            <div>{this.getSkills()}</div>
            <div className="about__padding" />
          </div>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js